import { OnInit, OnDestroy } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SelfService } from '../bpg-self-services/self-services.service.ts';
import { BpgEventsService } from '../bpg-events/bpg-events.service';
import { ConstantValues } from '../bpg-common/models/bpg-constants';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BpgCommonService } from '../bpg-common/services/bpg-common.service.js';
var SUCCESS_ALERT_DURATION = 5000;
var ERROR_ALERT_DURATION = 8000;
export function normalizeEmail(email) {
    return String(email != null ? email : '').trim().toLowerCase();
}
var TnCComponent = /** @class */ (function () {
    function TnCComponent(userService, bpgCommonService, bpgEventsService, spinner) {
        this.userService = userService;
        this.bpgCommonService = bpgCommonService;
        this.bpgEventsService = bpgEventsService;
        this.spinner = spinner;
        this.loginData = JSON.parse(localStorage.getItem('loginData') || '{}');
        this.userId = String(this.loginData && this.loginData.userId != null ? this.loginData.userId : '');
        this.userEmail = normalizeEmail(this.loginData && this.loginData.emailId != null ? this.loginData.emailId : '');
        this.isSuperAdmin = false;
        this.chapterId = null;
        this.bpgId = '';
        this.siteId = '';
        this.bpgName = null;
        this.siteName = null;
        this.selectedChapter = null;
        this.sponsorName = null;
        this.chairName = null;
        this.viceChairName = null;
        this.chairUserId = null;
        this.viceChairUserId = null;
        this.isLoading = true;
        this.hasUnsavedChanges = false;
        this.isSubmitting = false;
        this.isSubmitted = false;
        this.anySignatureCollected = false;
        this.showConfirmDialog = false;
        this.submittedDate = null;
        this.canSign = false;
        this.hasPolicyReadTMNA = false;
        this.hasPolicyReadTFS = false;
        this.hasPolicyReadTmmcEthics = false;
        this.hasPolicyReadTmmcPolicy = false;
        this.hasPolicyReadTmmcSolicitation = false;
        this.printedAt = '';
        this.alertSuccess = false;
        this.alertError = false;
        this.alertMessage = '';
        this.signatoryTypes = ['execSponsor', 'chair', 'viceChair'];
        this.payloadKeyMap = {
            execSponsor: { sign: 'executiveSponsorSigned', date: 'modifiedSponsorSignedDate' },
            chair: { sign: 'chairSigned', date: 'modifiedChairSignedDate' },
            viceChair: { sign: 'coChairSigned', date: 'modifiedCoChairSignedDate' }
        };
        this.userSignatoryTypes = [];
        this.userCanSignMap = {};
        this.destroy$ = new Subject();
        this.signatories = {
            execSponsor: { key: 'execSponsor', label: 'Executive Sponsor', data: null, date: null, signed: false },
            chair: { key: 'chair', label: 'Chair', data: null, date: null, signed: false },
            viceChair: { key: 'viceChair', label: 'Vice Chair or Co-Chair', data: null, date: null, signed: false },
        };
    }
    TnCComponent.prototype.ngOnInit = function () {
        var adminId = localStorage.getItem('adminId') || '';
        this.isSuperAdmin = adminId.split(',').some(function (roleId) { return roleId.trim() === '1'; });
        this.spinner.show();
        this.loadChapterData();
        this.logUserAction();
    };
    TnCComponent.prototype.logUserAction = function () {
        var data = {
            userId: this.userId,
            categoryDescription: "Acknowledgement Form",
        };
        this.bpgCommonService.logUserAction(data)
            .pipe(takeUntil(this.destroy$))
            .subscribe(function (_data) { });
    };
    TnCComponent.prototype.ngOnDestroy = function () {
        this.destroy$.next();
        this.destroy$.complete();
    };
    TnCComponent.prototype.loadChapterData = function () {
        var _this = this;
        var userAndRoleIdDTO = {
            userId: this.loginData['userId'],
            roleId: localStorage.getItem('adminId')
        };
        this.bpgEventsService.getChapterDropDown(userAndRoleIdDTO).pipe(takeUntil(this.destroy$)).subscribe(function (data) {
            _this.isLoading = false;
            if (!data || data.length === 0) {
                _this.spinner.hide();
                _this.showErrorAlert('No chapters found for your account.');
                return;
            }
            _this.chapterList = data;
            for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                var item = data_1[_i];
                item.chapterName = item.siteName + ' - ' + item.bpgName;
            }
            if (data.length === 1 && data[0]) {
                _this.chapterId = data[0].chapterId;
                _this.fetchChapterData(data[0].chapterId);
            }
            else {
                _this.spinner.hide();
            }
        }, function (error) {
            _this.isLoading = false;
            _this.spinner.hide();
            console.error('Error loading chapter dropdown:', error);
            _this.showErrorAlert('Failed to load chapter data.');
        });
    };
    TnCComponent.prototype.fetchChapterData = function (chapterId) {
        var _this = this;
        if (!chapterId) {
            return;
        }
        this.spinner.show();
        this.resetFormState();
        var landingDto = {
            filter: { chapterId: chapterId },
            moduleId: 0,
            page: 0,
            presentRole: '',
            searchTerm: '',
            size: ConstantValues.pageLimit,
            sortDirection: 'ASC',
            sortProperty: '',
            uid: ''
        };
        this.userService.getFullChapterList(landingDto).pipe(takeUntil(this.destroy$)).subscribe(function (data) {
            if (data && data.content && data.content.length > 0) {
                _this.populateChapterDetails(data.content[0]);
            }
            else {
                _this.spinner.hide();
                _this.showErrorAlert('No chapter details found.');
            }
        }, function (error) {
            _this.spinner.hide();
            console.error('Error loading chapter list:', error);
            _this.showErrorAlert('Failed to load chapter details.');
        });
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    TnCComponent.prototype.populateChapterDetails = function (chapter) {
        this.selectedChapter = chapter;
        this.chapterId = chapter.chapterId;
        this.bpgId = chapter.bpgId;
        this.siteId = chapter.siteId;
        this.bpgName = chapter.bpgName || null;
        this.siteName = chapter.siteName || null;
        if (chapter.chaptersExecutiveSponsor && chapter.chaptersExecutiveSponsor.length > 0) {
            this.sponsorObj = chapter.chaptersExecutiveSponsor[0];
            this.sponsorName = this.sponsorObj.executiveSponsorName || null;
        }
        this.chairUserId = null;
        this.viceChairUserId = null;
        if (chapter.chaptersLeadership && chapter.chaptersLeadership.length > 0) {
            for (var _i = 0, _a = chapter.chaptersLeadership; _i < _a.length; _i++) {
                var leader = _a[_i];
                if (!leader) {
                    continue;
                }
                switch (leader.positionName) {
                    case ConstantValues.leadershipPosition.chair:
                        this.chairObj = leader;
                        this.chairUserId = leader.userId != null ? String(leader.userId) : null;
                        break;
                    case ConstantValues.leadershipPosition.viceChair:
                        this.viceChairObj = leader;
                        this.viceChairUserId = leader.userId != null ? String(leader.userId) : null;
                        break;
                    default:
                        break;
                }
            }
        }
        this.fetchLeadershipNames();
    };
    TnCComponent.prototype.fetchLeadershipNames = function () {
        var _this = this;
        var landingDto = {
            filter: {
                siteId: this.siteId,
                bpgId: this.bpgId,
                leadershipPosition: 'EMPLOYEE'
            },
            moduleId: 0,
            page: 0,
            presentRole: '',
            searchTerm: '',
            size: 0,
            sortDirection: 'ASC',
            sortProperty: '',
            uid: ''
        };
        this.userService.getUserDropDown(landingDto).pipe(takeUntil(this.destroy$)).subscribe(function (data) {
            _this.leadershipList = data || [];
            _this.resolveLeadershipNames();
            _this.spinner.hide();
        }, function (error) {
            _this.spinner.hide();
            console.error('Error loading leadership list:', error);
        });
    };
    TnCComponent.prototype.resolveLeadershipNames = function () {
        var _this = this;
        this.chairName = this.resolveUserName(this.chairUserId, this.chairObj);
        this.viceChairName = this.resolveUserName(this.viceChairUserId, this.viceChairObj);
        for (var _i = 0, _a = this.signatoryTypes; _i < _a.length; _i++) {
            var type = _a[_i];
            this.userCanSignMap[type] = this.checkSignPermission(type);
        }
        this.canSign = this.signatoryTypes.some(function (t) { return _this.userCanSignMap[t]; });
        this.userSignatoryTypes = this.signatoryTypes.filter(function (t) { return _this.userCanSignMap[t]; });
        this.loadExistingSubmission();
    };
    TnCComponent.prototype.resolveUserName = function (userId, fallbackObj) {
        if (!userId) {
            return null;
        }
        var user = this.leadershipList.find(function (m) { return String(m.userId) === userId; });
        if (user) {
            return user.userFirstName + ' ' + user.userLastName;
        }
        return (fallbackObj && fallbackObj.emailAddress) || null;
    };
    TnCComponent.prototype.resetFormState = function () {
        this.selectedChapter = null;
        this.chapterId = null;
        this.bpgId = '';
        this.siteId = '';
        this.bpgName = null;
        this.siteName = null;
        this.sponsorName = null;
        this.chairUserId = null;
        this.viceChairUserId = null;
        this.chairName = null;
        this.viceChairName = null;
        this.sponsorObj = null;
        this.chairObj = null;
        this.viceChairObj = null;
        this.hasUnsavedChanges = false;
        this.alertSuccess = false;
        this.alertError = false;
        this.alertMessage = '';
        this.isSubmitting = false;
        this.isSubmitted = false;
        this.anySignatureCollected = false;
        this.showConfirmDialog = false;
        this.submittedDate = null;
        this.userCanSignMap = {};
        this.userSignatoryTypes = [];
        this.canSign = false;
        this.hasPolicyReadTMNA = false;
        this.hasPolicyReadTFS = false;
        this.hasPolicyReadTmmcEthics = false;
        this.hasPolicyReadTmmcPolicy = false;
        this.hasPolicyReadTmmcSolicitation = false;
        for (var _i = 0, _a = this.signatoryTypes; _i < _a.length; _i++) {
            var type = _a[_i];
            var sig = this.signatories[type];
            sig.data = null;
            sig.date = null;
            sig.signed = false;
        }
    };
    TnCComponent.prototype.goBack = function () {
        if (this.hasUnsavedChanges) {
            this.showConfirmDialog = true;
            return;
        }
        window.history.back();
    };
    TnCComponent.prototype.confirmGoBack = function () {
        this.showConfirmDialog = false;
        window.history.back();
    };
    TnCComponent.prototype.cancelGoBack = function () {
        this.showConfirmDialog = false;
    };
    TnCComponent.prototype.onSigInput = function (type, event) {
        var value = event.target.value;
        var sig = this.signatories[type];
        sig.data = value || null;
        sig.date = value ? new Date() : null;
        this.hasUnsavedChanges = this.hasAnyUserSignature;
    };
    TnCComponent.prototype.clearSignature = function (type) {
        var sig = this.signatories[type];
        if (!sig || !this.userCanSignMap[type] || sig.signed) {
            return;
        }
        sig.data = null;
        sig.date = null;
        if (!this.hasAnyUserSignature) {
            this.hasUnsavedChanges = false;
        }
    };
    TnCComponent.prototype.checkSignPermission = function (type) {
        switch (type) {
            case 'execSponsor': {
                var sponsorEmail = normalizeEmail(this.sponsorObj && this.sponsorObj.executiveSponsorEmailId);
                var loginEmail = normalizeEmail(this.userEmail);
                return !!(this.sponsorObj && sponsorEmail && loginEmail && sponsorEmail === loginEmail);
            }
            case 'chair':
                return !!(this.chairObj && String(this.chairObj.userId) === this.userId);
            case 'viceChair':
                return !!(this.viceChairObj && String(this.viceChairObj.userId) === this.userId);
            default:
                return false;
        }
    };
    TnCComponent.prototype.isSignatureLocked = function (type) {
        return !!(this.signatories[type] && this.signatories[type].signed);
    };
    TnCComponent.prototype.getSignatoryName = function (type) {
        switch (type) {
            case 'execSponsor': return this.sponsorName || 'Not assigned';
            case 'chair': return this.chairName || 'Not assigned';
            case 'viceChair': return this.viceChairName || 'Not assigned';
            default: return 'Unknown';
        }
    };
    TnCComponent.prototype.getSignaturePlaceholder = function (type) {
        if (!this.userCanSignMap[type]) {
            return '\u2014 Awaiting ' + this.getSignatoryName(type) + '\u2019s signature \u2014';
        }
        if (!this.isAnyPolicyRead()) {
            return 'Review a policy above to sign';
        }
        return 'Type your full name';
    };
    TnCComponent.prototype.getSignedCount = function () {
        var _this = this;
        return this.signatoryTypes.filter(function (t) { return _this.signatories[t].signed; }).length;
    };
    Object.defineProperty(TnCComponent.prototype, "isFormComplete", {
        get: function () {
            var _this = this;
            return this.signatoryTypes.every(function (t) { return _this.signatories[t].signed; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TnCComponent.prototype, "userHasSigned", {
        get: function () {
            var _this = this;
            return this.userSignatoryTypes.length > 0 &&
                this.userSignatoryTypes.every(function (t) { return _this.signatories[t].signed; });
        },
        enumerable: true,
        configurable: true
    });
    TnCComponent.prototype.getUserSignTooltip = function () {
        var _this = this;
        if (!this.chapterId) {
            return '';
        }
        if (this.userSignatoryTypes.length === 0) {
            return 'You are not authorized to sign for any role on this chapter.';
        }
        var labels = this.userSignatoryTypes.map(function (t) { return _this.signatories[t].label; }).join(', ');
        return 'You can sign for: ' + labels;
    };
    Object.defineProperty(TnCComponent.prototype, "hasAnyUserSignature", {
        get: function () {
            var _this = this;
            return this.userSignatoryTypes.some(function (t) { return !!_this.signatories[t].data; });
        },
        enumerable: true,
        configurable: true
    });
    TnCComponent.prototype.submitTnC = function () {
        if (this.isSubmitting) {
            return;
        }
        if (!this.isAnyPolicyRead()) {
            this.showErrorAlert('Please review at least one ERG Policy by clicking the links above before submitting.');
            return;
        }
        this.isSubmitting = true;
        if (!this.bpgName) {
            this.isSubmitting = false;
            this.showErrorAlert('Please ensure chapter information is loaded.');
            return;
        }
        var payload = this.buildAcceptPayload();
        if (!payload) {
            this.isSubmitting = false;
            this.showErrorAlert('Please enter your signature before submitting.');
            return;
        }
        this.submitAccept(payload);
    };
    TnCComponent.prototype.buildAcceptPayload = function () {
        var payload = { chapterId: this.chapterId };
        var hasSignature = false;
        for (var _i = 0, _a = this.userSignatoryTypes; _i < _a.length; _i++) {
            var type = _a[_i];
            var sig = this.signatories[type];
            if (sig && sig.data) {
                payload[this.payloadKeyMap[type].sign] = sig.data;
                payload[this.payloadKeyMap[type].date] = sig.date ? sig.date.toISOString() : new Date().toISOString();
                hasSignature = true;
            }
        }
        return hasSignature ? payload : null;
    };
    TnCComponent.prototype.submitAccept = function (payload) {
        var _this = this;
        this.userService.saveErgTnc(payload).pipe(takeUntil(this.destroy$)).subscribe(function () {
            for (var _i = 0, _a = _this.userSignatoryTypes; _i < _a.length; _i++) {
                var type = _a[_i];
                if (_this.signatories[type].data) {
                    _this.signatories[type].signed = true;
                }
            }
            _this.hasUnsavedChanges = false;
            _this.isSubmitting = false;
            _this.isSubmitted = true;
            _this.anySignatureCollected = true;
            _this.submittedDate = new Date();
            _this.showSuccessAlert('ERG Transition Acknowledgement Form submitted successfully!');
            _this.loadExistingSubmission();
        }, function (error) {
            _this.isSubmitting = false;
            console.error('Error submitting acceptance:', error);
            _this.showErrorAlert('Failed to submit. Please try again.');
        });
    };
    TnCComponent.prototype.loadExistingSubmission = function () {
        var _this = this;
        if (!this.chapterId || !this.userId) {
            return;
        }
        var payload = { chapterId: this.chapterId };
        this.userService.getErgTnc(payload).pipe(takeUntil(this.destroy$)).subscribe(function (next) {
            var data = Array.isArray(next) ? next[0] : next;
            if (!data) {
                return;
            }
            var hasAccepted = false;
            for (var _i = 0, _a = _this.signatoryTypes; _i < _a.length; _i++) {
                var type = _a[_i];
                var signKey = _this.payloadKeyMap[type].sign;
                var dateKey = _this.payloadKeyMap[type].date;
                var signValue = data[signKey];
                if (!signValue) {
                    continue;
                }
                hasAccepted = true;
                _this.signatories[type].data = signValue;
                _this.signatories[type].date = data[dateKey]
                    ? new Date(data[dateKey])
                    : new Date();
                _this.signatories[type].signed = true;
            }
            var latestSignatoryDate = _this.getLatestSignatoryDate();
            var resolvedDate = null;
            if (latestSignatoryDate) {
                resolvedDate = latestSignatoryDate;
            }
            else if (data.submittedDate) {
                resolvedDate = new Date(data.submittedDate);
            }
            if (hasAccepted) {
                _this.anySignatureCollected = true;
                _this.isSubmitted = _this.userSignatoryTypes.some(function (t) {
                    return _this.signatories[t].signed;
                });
                _this.submittedDate = resolvedDate;
            }
        }, function (error) {
            console.warn('No existing TnC submission found:', error);
        });
    };
    TnCComponent.prototype.dismissAlert = function () {
        this.alertSuccess = false;
        this.alertError = false;
        this.alertMessage = '';
    };
    TnCComponent.prototype.showSuccessAlert = function (message) {
        var _this = this;
        this.alertError = false;
        this.alertSuccess = true;
        this.alertMessage = message;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(function () { _this.alertSuccess = false; }, SUCCESS_ALERT_DURATION);
    };
    TnCComponent.prototype.showErrorAlert = function (message) {
        var _this = this;
        this.alertSuccess = false;
        this.alertError = true;
        this.alertMessage = message;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(function () { _this.alertError = false; }, ERROR_ALERT_DURATION);
    };
    Object.defineProperty(TnCComponent.prototype, "isTmmcSite", {
        get: function () {
            return (this.siteName || '').trim().toUpperCase() === 'TMMC';
        },
        enumerable: true,
        configurable: true
    });
    TnCComponent.prototype.isAnyPolicyRead = function () {
        return this.hasPolicyReadTMNA || this.hasPolicyReadTFS
            || this.hasPolicyReadTmmcEthics || this.hasPolicyReadTmmcPolicy || this.hasPolicyReadTmmcSolicitation;
    };
    TnCComponent.prototype.onPolicyLinkClicked = function (policyType) {
        switch (policyType) {
            case 'TMNA':
                this.hasPolicyReadTMNA = true;
                break;
            case 'TFS':
                this.hasPolicyReadTFS = true;
                break;
            case 'tmmcEthics':
                this.hasPolicyReadTmmcEthics = true;
                break;
            case 'tmmcPolicy':
                this.hasPolicyReadTmmcPolicy = true;
                break;
            case 'tmmcSolicitation':
                this.hasPolicyReadTmmcSolicitation = true;
                break;
        }
    };
    TnCComponent.prototype.trackByValue = function (_index, val) { return val; };
    TnCComponent.prototype.printForm = function () {
        var _this = this;
        this.printedAt = new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
        setTimeout(function () { window.print(); _this.printedAt = ''; }, 50);
    };
    TnCComponent.prototype.getLatestSignatoryType = function () {
        var latestType = null;
        var latestTime = 0;
        for (var _i = 0, _a = this.signatoryTypes; _i < _a.length; _i++) {
            var type = _a[_i];
            var sig = this.signatories[type];
            if (sig.signed && sig.date) {
                var time = sig.date.getTime();
                if (time > latestTime) {
                    latestTime = time;
                    latestType = type;
                }
            }
        }
        return latestType;
    };
    Object.defineProperty(TnCComponent.prototype, "latestSignatoryLabel", {
        get: function () {
            var type = this.getLatestSignatoryType();
            return type ? this.signatories[type].label : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TnCComponent.prototype, "printStatusLabel", {
        get: function () {
            var count = this.getSignedCount();
            var total = this.signatoryTypes.length;
            if (this.isFormComplete) {
                return 'Complete (' + total + ' of ' + total + ' signed)';
            }
            if (this.anySignatureCollected) {
                return 'Partially Signed (' + count + ' of ' + total + ')';
            }
            return 'No Signatures Yet';
        },
        enumerable: true,
        configurable: true
    });
    TnCComponent.prototype.getLatestSignatoryDate = function () {
        var type = this.getLatestSignatoryType();
        return type ? this.signatories[type].date : null;
    };
    return TnCComponent;
}());
export { TnCComponent };
